<template lang="pug">

</template>
<script>
import store from '@/store';
import _ from 'lodash';

export default {
    name: 'Forward',
    beforeRouteEnter(to, from, next) {
        const id = _.get(store, 'state.auth.user.id');
        next({ name: 'cms-account-main', params: { id } });
    }
}
</script>
